import React from 'react'
import FormItem from './FormItem'
import LabelItem from './LabelItem'
import Input from './Input'

type Props = {
  name: string
  label?: string
  placeHolder?: string
  onChange: (val: any, name: string) => void
  isError?: boolean
  value?: any
  type?: string
  isRequired?: boolean
  resProps?: object
  errorMsg?: string
  labelColor?: string
}

const AppInput = (props: Props): any => {
  const {
    label = '',
    name,
    isError = false,
    onChange,
    placeHolder = '',
    value,
    type = 'text',
    isRequired = false,
    resProps = {},
    errorMsg = '',
    labelColor,
  } = props

  const onChangeData = (val: string) => {
    const value = type === 'number' ? parseFloat(val) : val
    onChange(value, name)
  }

  return (
    <FormItem label="" status={isRequired && isError ? 'error' : ''} error={`กรุณาระบุ ${errorMsg || label}`}>
      {label && <LabelItem label={isRequired ? `${label}*` : label} color={labelColor} />}
      <Input
        type={type}
        placeholder={placeHolder || label}
        name={name}
        value={value}
        onChange={onChangeData}
        resProps={resProps}
      />
    </FormItem>
  )
}

export default AppInput
